
import { Component, Input, OnChanges } from 'angular-ts-decorators';

import { IAward } from '@gn-audio/core/api/marketing-documents/models';
import { fetchFamilyAwards } from '@gn-audio/core/api/marketing-documents/fetch-family-awards';
import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models';

import template from './hero-customizer-v3-award.component.html';

@Component({
  selector: 'heroCustomizerV3Award',
  template,
})
export class HeroCustomizerV3AwardComponent implements OnChanges {
  @Input() public group?: IProductWithAttributes;

  public award?: IAward;

  public async ngOnChanges() {
    const familyAwards: IAward[] | null = await fetchFamilyAwards(this.group.familyId);
    if (!familyAwards) {
      return;
    }

    const mainAward: IAward = familyAwards[0];
    this.award = mainAward;
  }

  public get shouldRenderAwardComponent(): boolean {
    return !!this.group && !!this.award;
  }
}
